import styles from '../../styles/admin/List.module.scss'

const ClassStatusListHeader = () => {
  return (
    <li className={styles.listHeader}>
      <div className={styles.cell} style={{ width: '50px' }}>
        Level
      </div>
      <div className={styles.cell} style={{ width: '50px' }}>
        Classes
      </div>
      <div className={styles.cell} style={{ width: '50px' }}>
        Questions
      </div>
    </li>
  )
}

export default ClassStatusListHeader
